var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_20160_35653)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.527 4.85092L3.23087 17.3485C3.08044 17.6158 3.00085 17.9188 3.00001 18.2275C2.99916 18.5361 3.0771 18.8396 3.22607 19.1078C3.37504 19.3759 3.58984 19.5994 3.84911 19.7559C4.10838 19.9125 4.40308 19.9966 4.70388 20H19.2961C19.5969 19.9966 19.8916 19.9125 20.1509 19.7559C20.4102 19.5994 20.625 19.3759 20.7739 19.1078C20.9229 18.8396 21.0008 18.5361 21 18.2275C20.9992 17.9188 20.9196 17.6158 20.7691 17.3485L13.473 4.85092C13.3194 4.59116 13.1032 4.3764 12.8452 4.22735C12.5872 4.0783 12.2961 4 12 4C11.7039 4 11.4128 4.0783 11.1548 4.22735C10.8968 4.3764 10.6806 4.59116 10.527 4.85092Z",
    stroke: "#FB923C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 16.583H12.01",
    stroke: "#FB923C",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 9.25V12.9167",
    stroke: "#FB923C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_20160_35653"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.0111b3242aa1d720f4530d50029e1c83.svg";
export { ForwardRef as ReactComponent };